module.exports = __webpack_public_path__ + "static/ai-superpowers-d05bbcb95f928e81518c068ffa167360.jpg";